import mondayPoster from './images/events/ctyri-elementy-pondeli.jpg';
import wednesdayPoster from './images/events/cesta-vetru-streda.jpg';

export const lessonEvents = [
    {
        id: 'ctyri-elementy',
        day: 'Pondělí',
        theme: 'Cesta mého vnitřního Já za 4 elementy',
        description: 'Pohyb, dech, harmonie a vnitřní síla. Autorská harmonizační sestava Tomáše Číhala.',
        poster: mondayPoster,
    },
    {
        id: 'cesta-vetru',
        day: 'Středa',
        theme: 'Cesta větru a šepot mého vnitřního Já',
        description: 'Lehkost, vědomý pohyb a dech větru. Autorská harmonizační sestava pro klid a vnitřní rovnováhu.',
        poster: wednesdayPoster,
    },
];
